<!-- 数据Column -->
<template>
    <div>
        <!-- //数据 1-温度，10-湿度，100-有效异常，1000-全部异常 -->
      <el-tag v-if="row['data'].split('')[0] === '1'" class="mr-5">{{ $t('public.temp') }}</el-tag>
      <el-tag v-if="row['data'].split('')[1] === '1'" class="mr-5">{{ $t('public.hum') }}</el-tag>
      <el-tag v-if="row['data'].split('')[2] === '1'" class="mr-5">{{ $t('selectMsg.effective') }}{{ $t('public.exception') }}</el-tag>
      <el-tag v-if="row['data'].split('')[3] === '1'" class="mr-5">{{ $t('public.All') }}{{ $t('public.exception') }}</el-tag>
      <el-tag v-if="row['data'].split('')[4] === '1'" class="mr-5">{{ $t('gasType.0x00') }}</el-tag>
      <el-tag v-if="row['data'].split('')[5] === '1'" class="mr-5">{{ $t('gasType.0x01') }}</el-tag>
      <el-tag v-if="row['data'].split('')[6] === '1'" class="mr-5">{{ $t('gasType.0x04') }}</el-tag>
      <el-tag v-if="row['data'].split('')[7] === '1'" class="mr-5">{{ $t('gasType.0x0A') }}</el-tag>
      <el-tag v-if="row['data'].split('')[8] === '1'" class="mr-5">{{ $t('gasType.0x32') }}</el-tag>
      <el-tag v-if="row['data'].split('')[9] === '1'" class="mr-5">{{ $t('equiType.magnetism') }}</el-tag>
    </div>
</template>

<script>
export default {
    props: ['row'],
    data() {
        return {

        }
    }
}
</script>